/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import type { ReactElement } from "react";
import { Helmet } from "react-helmet-async";

import { cssFns } from "@superweb/css";
import { useIsMobile, useUiColors } from "@superweb/ui";

import { PageHeader } from "#internal/ui";

export const AppLayout = ({
  title,
  offer,
  content,
  partnerName,
}: {
  title?: string;
  partnerName?: string;
  offer?: ReactElement;
  content: ReactElement;
}) => {
  const isMobile = useIsMobile();
  const uiColors = useUiColors();

  const isIframe = window.self !== window.top;

  return (
    <>
      {title && (
        <Helmet>
          <title>{title}</title>
        </Helmet>
      )}
      <div
        css={{
          display: "flex",
          flexDirection: "column",
          ...(isMobile
            ? { rowGap: "8px", ...cssFns.padding("10px") }
            : { rowGap: "20px", ...cssFns.padding("16px") }),
          backgroundColor: uiColors.backgroundMinor,
        }}
      >
        {!isIframe && <PageHeader partnerName={partnerName} />}
        <main
          css={{
            display: "grid",
            justifyItems: "center",
            height: `calc(100% - 32px)`,
          }}
        >
          <div
            css={{
              height: "100%",
              display: "flex",
              justifyContent: "start",
              flexDirection: "column",
              rowGap: "16px",
              maxWidth: "764px",
              width: "100%",
            }}
          >
            <div
              css={{
                flexGrow: "1",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                isolation: "isolate",
                boxSizing: "border-box",
                rowGap: "16px",
              }}
            >
              {offer}
              <div
                css={{
                  flexGrow: "1",
                  backgroundColor: uiColors.background,
                  ...cssFns.border({ radius: "26px" }),
                }}
              >
                {content}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};
